"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(number, index) {
    return [
        ['éppen most', 'éppen most'],
        ['%s másodperce', '%s másodpercen belül'],
        ['1 perce', '1 percen belül'],
        ['%s perce', '%s percen belül'],
        ['1 órája', '1 órán belül'],
        ['%s órája', '%s órán belül'],
        ['1 napja', '1 napon belül'],
        ['%s napja', '%s napon belül'],
        ['1 hete', '1 héten belül'],
        ['%s hete', '%s héten belül'],
        ['1 hónapja', '1 hónapon belül'],
        ['%s hónapja', '%s hónapon belül'],
        ['1 éve', '1 éven belül'],
        ['%s éve', '%s éven belül'],
    ][index];
}
exports.default = default_1;
//# sourceMappingURL=hu.js.map